/* eslint-disable react/jsx-props-no-spreading, max-len */
import Icon from '../components/Icon'
import categories from './categories'

function ArrowHookLeft(props) {
  return (
    <Icon {...props}>
      <path d="M8.83,14 L12.42,17.58 L11,19 L5,13 L11,7 L12.42,8.42 L8.83,12 L15,12 C16.6568542,12 18,10.6568542 18,9 C18,7.40231912 16.75108,6.09633912 15.1762728,6.00509269 L15,6 L14,6 L14,4 L15,4 C17.7614237,4 20,6.23857625 20,9 C20,11.6887547 17.8776933,13.8818181 15.2168896,13.9953805 L15,14 L8.83,14 Z" id="Path" />
    </Icon>
  )
}

ArrowHookLeft.tags = ['Replied']
ArrowHookLeft.category = categories.messages

export default ArrowHookLeft
